<template>
  <div class="education">
    <div class="top-banner">
      学 历 教 育
    </div>
    <!-- 学历提升政策 -->
    <div class="education-policy">
      <div class="g-box">
        <div class="top-title">合作院校</div>
        <div class="sub-title">Education promotion policy</div>
        <div class="content">
          <div class="item" v-for="item in policyList" :key="item.id">
            <img class="img" :src="item.image" alt="" />
            <!-- <div class="title">
              {{ item.title }}
            </div>
            <div class="img-block">
              <img class="img" :src="item.image" alt="" />
            </div>
            <div class="intro">
              {{ item.subtitle }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 提升学历的6大优势 -->
    <div class="education-advantage">
      <div class="g-box">
        <div class="top-title">提升学历的6大优势</div>
        <div class="sub-title">
          Six advantages of improving academic qualifications
        </div>
        <div class="content">
          <img class="img" :src="advantageInfo.image" alt="" />
        </div>
      </div>
    </div>
    <!-- 特色教学 -->
    <div class="education-spacial">
      <div class="g-box">
        <div class="top-title">特色教学</div>
        <div class="sub-title">
          Characteristic teach
        </div>
        <div class="content">
          <div class="item" v-for="item in spacialList" :key="item.id">
            <img class="img" :src="item.image" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 优秀班主任 -->
    <div class="education-teacher">
      <div class="g-box">
        <div class="top-title">优秀班主任</div>
        <div class="sub-title">
          Excellent class teac
        </div>
        <div class="content">
          <div class="item" v-for="item in teacherList" :key="item.id">
            <div class="item-le">
              <div class="avatar">
                <img :src="item.image" alt="" class="img" />
              </div>
              <div class="name">{{ item.title }}</div>
              <div class="time">{{ item.subtitle }}</div>
            </div>
            <div class="item-ri">
              <div class="tip"></div>
              <div class="assess">
                {{ item.tips }}
              </div>
              <div class="line"></div>
              <div class="intro">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      teacherList: [],
      policyList: [],
      spacialList: [],
      advantageInfo: {}
    };
  },
  components: {},
  async mounted() {
    //banner

    // 学历提升政策
    const menuId2 = this.getMenuId("学历业务-业务介绍-学历提升政策");
    if (menuId2) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId2
      });
      console.log(data, "datataimg");
      this.policyList = data;
    }

    // 优秀班主任
    const menuId3 = this.getMenuId("优秀班主任");
    if (menuId3) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId3
      });
      this.teacherList = data;
    }

    // 提升学历的6大优势
    const menuId4 = this.getMenuId("学历业务-业务介绍-提升学历的6大优势");
    if (menuId4) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId4
      });
      this.advantageInfo = data[0] || {};
    }
    // 特色教学
    const menuId5 = this.getMenuId("学历业务-业务介绍-特色教学");
    if (menuId5) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId5
      });
      this.spacialList = data;
    }
  },
  methods: {}
};
</script>
<style lang="less">
.education {
  .top-banner {
    padding-top: 80px;
    text-align: center;
    height: 280px;
    background: url("../../assets/img/education-bg.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    font-size: 60px;
    color: #fff;
    line-height: 84px;
    letter-spacing: 8px;
  }
  //  学历提升政策
  &-policy {
    padding: 90px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #202930;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: -20px;
      text-align: center;
      text-transform: uppercase;
      font-size: 20px;
      font-weight: 600;
      color: rgba(20, 101, 245, 0.2);
    }
    .content {
      margin-top: 50px;
      display: flex;
      justify-content: center;
      .item {
        margin-right: 40px;
        // padding: 30px 20px;
        width: 580px;
        height: 420px;
        box-sizing: border-box;
        border: 1px solid #e0e0e0;
        .title {
          width: 540px;
          text-align: center;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 20px;
          font-weight: 600;
          color: #202930;
        }
        .img-block {
          padding-top: 20px;
          width: 540px;
          height: 200px;

          .img {
            width: 540px;
            height: 200px;
          }
        }
        .intro {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 540px;
          padding-top: 20px;
          font-size: 14px;
          color: #656878;
        }
        .img {
          width: 580px;
          height: 420px;
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
  // 提升学历的6大优势
  &-advantage {
    padding-top: 70px;
    height: 820px;
    box-sizing: border-box;
    background: url("../../assets/img/advantage-bg.png") no-repeat;
    background-size: cover;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #fff;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: -20px;
      text-align: center;
      text-transform: uppercase;
      font-size: 20px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.2);
    }
    .content {
      margin-top: 60px;
      .img {
        width: 1200px;
        height: 540px;
      }
    }
  }
  // 特色教学
  &-spacial {
    padding-top: 80px;
    height: 1210px;
    box-sizing: border-box;
    background: url("../../assets/img/spacial-bg.png") no-repeat;
    background-size: cover;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #202930;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: -20px;
      text-align: center;
      text-transform: uppercase;
      font-size: 20px;
      font-weight: 600;
      color: rgba(20, 101, 245, 0.2);
    }
    .content {
      margin-top: 60px;
      .item {
        margin-bottom: 40px;
        width: 1200px;
        height: 280px;
        .img {
          width: 1200px;
          height: 280px;
        }
      }
    }
  }
  // 优秀班主任
  &-teacher {
    padding: 80px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #202930;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: -20px;
      text-align: center;
      text-transform: uppercase;
      font-size: 20px;
      font-weight: 600;
      color: rgba(20, 101, 245, 0.2);
    }
    .content {
      margin-top: 90px;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 70px;
        padding: 30px;
        width: 580px;
        height: 230px;
        display: flex;
        box-sizing: border-box;
        background-image: url("../../assets/img/teacher-bg.png");
        background-repeat: no-repeat;
        cursor: pointer;
        &-le {
          position: relative;
          top: -60px;
          .avatar {
            width: 120px;
            height: 150px;
            .img {
              width: 120px;
              height: 150px;
              border-radius: 8px;
            }
          }
          .name {
            padding-top: 20px;
            font-size: 18px;
            font-weight: 600;
            color: #202930;
          }
          .time {
            padding-top: 10px;
            color: #202930;
          }
        }
        &-ri {
          margin-left: 30px;
          .tip {
            width: 24px;
            height: 24px;
            background-image: url("../../assets/img/icon1.png");
          }
          .assess {
            padding-top: 4px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .line {
            margin-top: 14px;
            width: 32px;
            height: 2px;
            background: #1465f5;
          }
          .intro {
            padding-top: 20px;
            font-size: 12px;
            color: #202930;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .item:hover {
        background-image: url("../../assets/img/teacher-bg2.png");
        .item-le {
          .name {
            color: #fff;
          }
          .time {
            color: #fff;
          }
        }
        .item-ri {
          .tip {
            background-image: url("../../assets/img/icon2.png");
          }
          .assess {
            color: #fff;
          }
          .line {
            background: #fff;
          }
          .intro {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
